/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import Typography from "@mui/material/Typography";
import MuiListNativeStyled from "@/src/components/List/MuiListNativeStyled";

const Benefits = () => {
  return (
    <>
      <Typography component={"h2"} variant={"h6"} sx={jobStyles.text}>
        Was wir Dir bieten und was uns auszeichnet
      </Typography>
      <MuiListNativeStyled
        sx={jobStyles.list}
        listItems={[
          "Eine anspruchsvolle Arbeit in einem hochmotivierten Team, in dem Du Deine Karriere auf das nächste Level bringen kannst – persönliche und berufliche Weiterentwicklungsmöglichkeiten inklusive",
          "Die Chance, viel zu lernen und Verantwortung zu übernehmen. Wir entscheiden und arbeiten mit vollem Kundenfokus und umsetzungsstark, um unseren Kunden das bestmögliche Erlebnis zu bieten",
          "Eine tolle Arbeitsatmosphäre in einem modernen Büro im Kranhaus mit phantastischem Blick auf den Rhein und sehr guter Erreichbarkeit mit öffentlichen Verkehrsmitteln",
          "Du möchtest auch von Zuhause arbeiten? Kein Problem: Flexible Arbeitszeitgestaltung und Home-Office sind bei uns selbstverständlich",
          "Goodies, wie Deutschlandticket & Zuschuss zum Urban-Sports-Club, gibt es natürlich on top",
        ]}
      />
    </>
  );
};

export default Benefits;
